import axiosClient from "./axiosClient";
import { apiEndpoints, secureBusinessKey } from "./apiEndpoints";
import Cookies from "js-cookie";
import { Bounce, toast } from "react-toastify";
export const updateEcommerceID = (ecomm_order_id, reservation_id) => {
  const sessionExpired = (msg) => {
    toast(msg, {
      style: {
        background: "#f87171",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "2rem",
        padding: "1rem",
        width: "20dvh",
      },
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      pauseOnHover: true,
      draggable: true,
      progress: 0,
      theme: "colored",
      transition: Bounce,
      closeButton: ({ closeToast }) => (
        <button
          className="text-white text-4xl leading-none rounded-full p-2"
          onClick={closeToast}
        >
          ×
        </button>
      ),
    });
  };

  const personal_token = Cookies.get("personal_token");

  if (!personal_token) {
    sessionExpired("Session has expired");
    setTimeout(() => {
      window.location.href = "/logout";
    }, 3000);
    return Promise.reject(
      new Error("Personal Token is missing. Redirecting to logout.")
    );
  }
  return axiosClient.post(
    apiEndpoints.updateEcommID.url(reservation_id),
    { ecomm_order_id: ecomm_order_id },
    {
      headers: {
        "secure-business-key": secureBusinessKey,
        "Content-Type": "application/json",
        "user-token": personal_token,
      },
    }
  );
};
